import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// IMPORTANT: capture the URL hash + search BEFORE BrowserRouter mounts.
// react-router-dom v6 normalises the URL on init via history.replaceState
// which strips the hash — wiping our social-login session_id / token /
// error fragments before SocialFinishPage can read them.
if (typeof window !== "undefined") {
  window.__fgInitialHash = window.location.hash || "";
  window.__fgInitialSearch = window.location.search || "";
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
